(function () {
  document.querySelectorAll('[data-sova-ugc]').forEach(function (root) {
    var marquee = root.querySelector('[data-sova-ugc-marquee]');
    var track = root.querySelector('[data-sova-ugc-track]');
    if (!marquee || !track) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          track.classList.toggle('is-paused', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(marquee);
    }

    var isDown = false;
    var startX = 0;
    var scrollStart = 0;

    marquee.addEventListener('touchstart', function (e) {
      isDown = true;
      startX = e.touches[0].clientX;
      scrollStart = marquee.scrollLeft;
      track.classList.add('is-paused');
    }, { passive: true });

    marquee.addEventListener('touchmove', function (e) {
      if (!isDown) return;
      marquee.scrollLeft = scrollStart - (e.touches[0].clientX - startX);
    }, { passive: true });

    marquee.addEventListener('touchend', function () {
      isDown = false;
      window.setTimeout(function () { track.classList.remove('is-paused'); }, 1200);
    });
  });
})();
